import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";

const TransparencyIcon = {
  name: 'TransparencyIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function (s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function (h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' 
      ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em'
      : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "stroke-width": "0px"
      },
      "class": "feather feather-transparency"
    }, ctx.data]), [
      h("g", {
        attrs: {
          opacity: "0.7"
        }
      }, [
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M16.2374 8.69076L11.2784 13.6522L8.32605 10.6952L9.38755 9.63537L11.279 11.5298L15.1764 7.63037L16.2374 8.69076Z",
            fill: "currentColor"
          }
        }),
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M3.38281 2.25H20.6185V12.0503C20.6185 15.6748 18.4375 18.1096 16.3728 19.5965C15.3359 20.3433 14.3038 20.8706 13.5331 21.2112C13.1468 21.3819 12.8234 21.5069 12.5942 21.5899C12.4796 21.6315 12.3884 21.6626 12.3244 21.6837C12.2924 21.6943 12.2673 21.7024 12.2494 21.7081L12.228 21.7147L12.2216 21.7167L12.2194 21.7174C12.2191 21.7175 12.218 21.7178 12.0006 21C11.7833 21.7178 11.783 21.7177 11.7827 21.7176L11.7797 21.7167L11.7732 21.7147L11.7519 21.7081C11.734 21.7024 11.7088 21.6943 11.6768 21.6837C11.6129 21.6626 11.5216 21.6315 11.407 21.5899C11.1779 21.5069 10.8545 21.3819 10.4681 21.2112C9.69751 20.8706 8.66538 20.3433 7.62843 19.5965C5.56372 18.1096 3.38281 15.6748 3.38281 12.0503V2.25ZM12.0006 21L11.7827 21.7176L12.0006 21.7836L12.218 21.7178L12.0006 21ZM12.0006 20.2092C12.0261 20.2002 12.0537 20.1904 12.0832 20.1797C12.2843 20.1068 12.5756 19.9944 12.9268 19.8391C13.6314 19.5278 14.5662 19.0491 15.4963 18.3793C17.3655 17.0332 19.1185 14.9932 19.1185 12.0503V3.75H4.88281V12.0503C4.88281 14.9932 6.63581 17.0332 8.50501 18.3793C9.43502 19.0491 10.3699 19.5278 11.0744 19.8391C11.4257 19.9944 11.717 20.1068 11.9181 20.1797C11.9476 20.1904 11.9751 20.2002 12.0006 20.2092Z",
            fill: "currentColor"
          }
        })
      ])
    ]);
  }
};

export default TransparencyIcon; 